export const openExternalUrl = url => {
  if (!url) return;

  try {
    const parsed = new URL(url);
    if (!['http:', 'https:'].includes(parsed.protocol)) return;
    window.open(parsed.toString(), '_blank', 'noopener');
  } catch {
    // Invalid URL -> do nothing
  }
};
